import { useQuery } from '@apollo/client'
import React, { createContext, FC } from 'react'
import { IAboutPage, IImageTickerItem, IPlayer } from '../components/types'
import { createAboutContent } from '../lib/createAboutContent'
import { createPartners } from '../lib/createPartners'
import { createVideo } from '../lib/createVideo'
import { getAboutPageVariables } from '../lib/gql'
import { getImageSrc } from '../lib/utils'
import { ABOUT } from '../queries/aboutQuery'
import { about, aboutVariables } from '../__generated__/about'

interface IAboutContext {
  title: string
  subtitle?: string
  description?: string
  topPicture?: string
  content: IAboutPage
  video: IPlayer
  code: string
  partners: IImageTickerItem[]
}
export const AboutContext = createContext({} as IAboutContext)

const AboutProvider: FC<{ code: string }> = ({ children, code }) => {
  const { data } = useQuery<about, aboutVariables>(ABOUT, {
    variables: getAboutPageVariables(code as string),
  })

  const title = data?.element?.name
  const subtitle = data?.element?.previewText
  const description = data?.element?.detailText
  const content = createAboutContent(data?.element)
  const topPicture = getImageSrc(data?.element?.detailPicture?.url) || ''
  const video = createVideo(data?.video)
  const partners = createPartners(data?.partners?.edges)

  return (
    <AboutContext.Provider
      value={{
        title,
        subtitle,
        description,
        content,
        topPicture,
        video,
        code,
        partners,
      }}
    >
      {children}
    </AboutContext.Provider>
  )
}
export default AboutProvider
